import FDScreenshot from './FitDice/fd.png';
import MFPscreenshot from './mfp/mfp.png';
import MBscreenshot from './mathbuddies/mathbuddies.png';
import CoolnessQuizScreenshot from './cq/cq.png';
import BetItAllScreenshot from './BetItAll/bia.png';
import ChordateQuizScreenshot from './Chordates/chordates.png';
import TimeFreezeScreenshot from './TimeFreeze/timefreeze.png';
import LandCMathScreenshot from './landcmath/landc.png';
import AngryPotatoesScreenshot from './AngryPotatoes/ap.png';
import ColorDeceptionScreenshot from './ColorDeception/cd.png';
import CarSmashScreenshot from './CarSmash/cs.png';
import Prayed4Screenshot from './Prayed4/prayed4.png';
import ProfilePic from './mjfeldy/profile.png';
import Mosaic1 from './mjfeldy/mosaic-new-1.png';
import Mosaic2 from './mjfeldy/mosaic-new-2.png';

import { useEffect } from 'react';
import './App.css';

const PROJECTS = [
  {
    date: 'September 2024 – Present',
    title: 'Mjfeldy Mosaic Maker',
    description: (
      <>
        Created a web app for <a href="https://www.youtube.com/@mjfeldy">my younger brother's YouTube channel</a> that turns images into LEGO mosaic instructions.
        Hundreds of mosaics have been generated using the site!
        <br />
        <br />
      </>
    ),
    tech: 'Originally Ruby on Rails, then converted to use Cloudflare Workers',
    links: [
      { label: 'mjfeldy.com', href: 'https://mjfeldy.com' },
      {
        label: 'Example of a mosaic my brother and I built',
        href: 'https://www.instagram.com/reel/C_vUeCIpxdW/?igsh=YnM0N2VndnZmMmNq',
      },
    ],
    images: [Mosaic1, Mosaic2],
  },
  {
    date: 'May 2022 – April 2026',
    title: 'Prayed4 Mobile App',
    description: (
      <>
        Created mobile app with my cousin that allows members to share prayer with one another.
        <br />
        <br />
        Over 3k prayers have been sent on the platform, with 500+ prayer requests, 45 prayer groups, and 190+ users.
      </>
    ),
    tech: 'Flutter, Dart, Firebase, OneSignal, JS',
    image: Prayed4Screenshot,
  },
  {
    date: 'March 2021 – February 2022',
    title: 'Maverick Food Pantry Mobile/Web Apps',
    subtitle: 'NuCo Studio',
    description: <>Created mobile app that allows users to order food pantry items, and a web app that allows <a href="https://www.unomaha.edu/student-life/civic-and-social-responsibility/maverick-food-pantry.php">Maverick Food Pantry</a> administrators to manage inventory, change order status, and send notifications. The app is currently in TestFlight.</>,
    tech: 'Flutter, Dart, Firebase, OneSignal, Angular, TypeScript',
    links: [{ label: "Video of UNO's chancellor featuring the mobile app", href: 'https://www.youtube.com/watch?v=NCjTGfdr7JY' }],
    image: MFPscreenshot,
  },
  {
    date: 'March 2021 – September 2021',
    title: 'Fit Dice',
    subtitle: 'Nascent LLC',
    description: <>A fun app I made with a friend during the pandemic that is based on the <a href="https://www.amazon.com/SPRI-07-71602-Exercise-Dice-6-Sided/dp/B079QR15YJ/ref=sr_1_7?crid=33VUX1W3LXE7E&keywords=fitness+dice&qid=1640968440&sprefix=fitness+dic%2Caps%2C105&sr=8-7">foam workout dice</a> we know and love.</>,
    tech: 'Flutter, Dart',
    image: FDScreenshot,
  },
  {
    date: 'January 2020 – September 2020',
    title: 'Human+ (formerly Sojourn)',
    description: <>A couple friends and I worked to make an idea come to life that a <a href="https://www.unomaha.edu/scott-scholars/index.php">UNO Scott Scholar</a> faculty member had. Inspired by the belief that many of today's global problems are the result of a lack of understanding of/connection to other races, cultures, and religions, the idea for Human+ was born. The purpose of Human+ was to shrink the psychological distance between people and problems by creating a safe online learning community that allows individuals to connect with, learn from, and begin to care for others in different parts of the world.</>,
    tech: 'Xcode and Swift for first prototype, and then Flutter, Dart, and Firebase for next iteration',
    links: [{ label: 'Article featuring Sojourn (scroll halfway down)', href: 'https://siliconprairienews.com/2021/08/beyond-slacktivism-samaritan-and-the-rise-of-app-tivism/' }],
  },
  {
    date: 'October 2019 – November 2019',
    title: 'Math Buddies',
    description: <>When I was in elementary school I always wished there was a better way to get more comfortable with simple math problems, so a friend and I decided to create an iPad app for that. Two students go head completing math problems - whoever answers correctly first gets a point!</>,
    tech: 'Xcode, Swift',
    image: MBscreenshot,
  },
  {
    date: 'Released November 2019',
    title: 'Coolness Quiz',
    description: <>Second simple quiz app I made to get familiar with Swift and putting apps on the app store again.</>,
    tech: 'Xcode, Swift',
    image: CoolnessQuizScreenshot,
    imageMaxWidth: 240,
  },
  {
    date: 'Released July 2015',
    title: 'Bet it ALL',
    description: <>Simple app where the user chooses an amount to wager, and they either gain or lose that amount. I learned how to integrate Game Center with this app.</>,
    tech: 'Xcode, Swift',
    image: BetItAllScreenshot,
  },
  {
    date: 'Released April 2015',
    title: 'Chordate Quiz',
    description: <>Simple quiz app I made for a science presentation freshman year of high school. Quizzes the user on the phylum chordata.</>,
    tech: 'Xcode, Swift',
    image: ChordateQuizScreenshot,
  },
  {
    date: 'Released March 2015',
    title: 'Time Freeze',
    description: <>App where the user tries to stop a timer at exactly 1 second. The idea came to me when I was trying to do this on a stopwatch, and figured it might be cool in app form. I learned about Swift and Xcode while developing this app, and it was also my first time integrating mobile ads.</>,
    tech: 'Xcode, Swift',
    image: TimeFreezeScreenshot,
  },
  {
    date: 'Released December 2014',
    title: 'L&C Math',
    description: <>The <a href="https://lewisandclark.bellevuepublicschools.org">Lewis and Clark Middle School</a> robotics team came up with the idea for this app and a friend and I developed it. L&C Math gives students practice using the order of operations, solving equations, and adding and subtracting integers. There is a game for all three topics in the app, and the robotics team created a series of <a href="https://basketball8407.wixsite.com/landcmath/lessons">videos</a> covering these topics.</>,
    tech: 'Multimedia Fusion 2',
    image: LandCMathScreenshot,
  },
  {
    date: 'Released November 2014',
    title: 'Angry Potatoes',
    description: <>Instead of Angry Birds, I thought it would be funny to create Angry Potatoes! In this game you toss potatoes into a pot of water while accounting for different wind speeds. I created the functionality while one of my friends did the graphic design.</>,
    tech: 'Multimedia Fusion 2',
    image: AngryPotatoesScreenshot,
  },
  {
    date: 'Released November 2014',
    title: 'Color Deception',
    description: <>Inspired by the <a href="https://en.wikipedia.org/wiki/Stroop_effect">Stroop test</a>, I created an app to test how well people could identify the color of the text representing a color rather than what the text reads.</>,
    tech: 'Multimedia Fusion 2',
    image: ColorDeceptionScreenshot,
  },
  {
    date: 'Released October 2014',
    title: 'Car Smash',
    description: <>Game where the user has to tap on only a certain color/type of car as vehicles cross the screen at varying speeds.</>,
    tech: 'Multimedia Fusion 2',
    image: CarSmashScreenshot,
  },
  {
    date: 'Released April 2014',
    title: "Jumpin' Jellyfish",
    description: <>Created a game with a couple junior high friends for the <a href="https://www.omahazoo.com/">Henry Doorly Zoo</a> in partnership with UNO. We wanted to provide entertainment for kids during idle time at the zoo, so we made an app where you have to tap as fast as you can on your screen to make a jellyfish move upwards. We also included an educational section of the app where users could learn more about jellyfish.</>,
    tech: 'Multimedia Fusion 2',
  },
  {
    date: 'Released July 2013',
    title: 'Bball-Stats',
    description: <>My first app ever! I played a lot of basketball in elementary school, and I thought it would be helpful if my coaches had a way to track stats during games. Bball-stats allowed coaches to mark where players were shooting from, shot percentages, and free throw percentages.</>,
    tech: 'Multimedia Fusion 2',
  },
];

function ProjectCard({ date, title, subtitle, description, tech, links, image, images, imageMaxWidth }) {
  return (
    <article className="project-card">
      <div className="project-header">
        <h2 className="project-title">
          {title} <span className="project-title-date">{date}</span>
        </h2>
      </div>
      {subtitle && <p className="project-subtitle">{subtitle}</p>}
      <div className="project-description">{description}</div>
      <p className="project-tech">Technologies used: {tech}</p>
      {links && links.length > 0 && (
        <div className="project-links">
          {links.map((link) => (
            <a key={link.href} href={link.href} target="_blank" rel="noopener noreferrer">
              {link.label}
            </a>
          ))}
        </div>
      )}
      {image && (
        <div className="project-image" style={imageMaxWidth ? { maxWidth: imageMaxWidth + 'px' } : undefined}>
          <img src={image} alt={title} />
        </div>
      )}
      {images && images.length > 0 && (
        <div className="project-image-row" aria-label={`${title} screenshots`}>
          {images.map((src, idx) => (
            <div key={src} className="project-image project-image--rowItem">
              <img src={src} alt={`${title} screenshot ${idx + 1}`} />
            </div>
          ))}
        </div>
      )}
    </article>
  );
}

function App() {
  useEffect(() => {
    const anchors = document.querySelectorAll('a[href]');
    anchors.forEach((a) => {
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener noreferrer');
    });
  }, []);

  return (
    <div className="app">
      <div className="container">
        <header className="hero">
          <img className="avatar" src={ProfilePic} alt="Michael Feldmann" />
          <h1>Michael Feldmann</h1>
          <p className="subtitle">Personal software projects in reverse chronological order</p>
        </header>
        <section className="projects">
          {PROJECTS.map((project) => (
            <ProjectCard key={project.title} {...project} />
          ))}
        </section>
        <footer className="footer">
          <p>Born August 1999</p>
        </footer>
      </div>
    </div>
  );
}

export default App;
